import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonRole } from '../../../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vle-group-renderer',
  templateUrl: 'group-renderer.component.html',
  styleUrls: ['group-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupRendererComponent implements ICellRendererAngularComp {
  cellParams: ICellRendererParams;
  hasChild: boolean;
  isExpand: Observable<boolean>;

  buttonRole = ButtonRole.Plain;

  agInit(params: ICellRendererParams): void {
    this.cellParams = params;
    this.hasChild = !!params.data.children?.length;

    const { context, node } = params;
    this.isExpand = context.componentParent.$openGroupIds.pipe(map((items: string[]) => items.includes(node.data.id)));

    if (params.data.isExpanded) {
      this.onExpandButtonClick(false, true);
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  onExpandButtonClick(isExpand: boolean, shouldPreventEmit?: boolean): void {
    const { context, node } = this.cellParams;

    if (isExpand) {
      context.componentParent.removeChildRow(node);
    } else {
      context.componentParent.addChildRow(node);
    }

    if (!shouldPreventEmit) {
      context.componentParent.onRowExpandToggle({
        isExpanded: !isExpand,
        data: node.data
      });
    }
  }
}
